<template>
  <div class="app-wrapper">
    <div class="layout-main-header">
      <layout-header @showLogin="showLogin" />
    </div>
    <div class="layout-main-container">
      <div class="layout-main-left">
        <layout-slider />
      </div>
      <div class="layout-main-right">
        <div class="layout-right-content" ref="demo">
          <app-main />
        </div>
      </div>
      <div class="layout-main-aides" v-show="!isChatRoute">
        <aides :aidesCode="aidesCode" :qunCode="qunCode" />
      </div>
    </div>
    <iframe v-if="isShowLogin" id="loginIrame" :src="loginUrl" />
    <user-info v-if="isNewUser && isUserDialog" @close="closeUserInfoDialog" />
    <user-center v-if="isUserEditDialog" />
    <Order />
  </div>
</template>

<script>
import sensors from "sa-sdk-javascript";
import { getUserInfo } from "@/api/user";
import { getQrcodeInfo } from "@/api/common";
import sObserver from "@/utils/simpleObserver";
import { setCookie } from "@/utils/token";
import UserCenter from "@/views/my/components/usercenter";
import Order from "@/views/my/components/order";
import { mapGetters } from "vuex";
import { AppMain, LayoutHeader, LayoutSlider, UserInfo } from "./components";
import aides from "./components/aides";
import router from "@/router";

export default {
  name: "Layout",
  components: {
    AppMain,
    LayoutSlider,
    LayoutHeader,
    UserInfo,
    aides,
    UserCenter,
    Order,
  },
  computed: {
    ...mapGetters(["isNewUser", "userInfo", "isUserEditDialog"]),
    isChatRoute() {
      return this.$route.path.indexOf("/chat") > -1;
    },
  },
  data() {
    return {
      isShowLogin: false,
      loginUrl: "",
      isUserDialog: true,
      aidesCode: "",
      qunCode: "",
      allUrl: window.location.href,
    };
  },
  mounted() {
    const { VUE_APP_LOGIN } = process.env;
    const bd_vid = router.currentRoute.query.bd_vid;
    console.log("router", router.currentRoute.query.bd_vid);
    if (bd_vid) {
      this.loginUrl =
        VUE_APP_LOGIN + "&bd_vid=" + bd_vid + "&all_url=" + this.allUrl;
      console.log("this.loginUrl", this.loginUrl);
      setCookie("bd_vid", bd_vid);
    } else {
      this.loginUrl = VUE_APP_LOGIN;
    }

    /**
     * 监听登陆页相关消息
     */
    const _this = this;
    window.addEventListener("message", async (e) => {
      if (typeof e.data !== "string") return;

      try {
        // 检查是否是有效的JSON格式
        if (e.data.trim().startsWith("{")) {
          const { type, data } = JSON.parse(e.data);

          switch (type) {
            case "w.login.closeDlg":
              _this.isShowLogin = false;
              break;
            case "w.login.success":
              _this.isShowLogin = false;
              setCookie("tal_token", data.token, 10);
              // 埋点
              const res = await getUserInfo();
              this.$store.commit("user/SET_USERINFO", {
                data: { userInfo: { ...res.data } },
              });
              sensors.track("login_success");
              _this.$router.go(0);
              break;
          }
        } else {
          console.log("收到非JSON格式消息，跳过处理:", e.data);
        }
      } catch (error) {
        console.error("消息解析错误:", error, "原始消息:", e.data);
      }
    });
    sObserver.watchWithCache("laoshibang-login", (d) => {
      _this.isShowLogin = true;
      sensors.track("login_show");
    });
    this.getQrcodeInfo();
  },
  beforeDestroy() {
    // 移除消息事件监听器
    window.removeEventListener("message", (e) => {
      console.log("移除消息事件监听器", e);
    });
    this.loginUrl = "";
  },
  watch: {
    $route: {
      handler(newVal) {
        // 获取当前页面url，要带path
        this.allUrl = window.location.href;
        console.log("this.AllUrl", this.allUrl);
        setCookie("all_url", this.allUrl);
      },
    },
  },
  methods: {
    getQrcodeInfo() {
      getQrcodeInfo().then((res) => {
        if (res.code === 200) {
          const { data } = res;
          this.aidesCode = data[0].image;
          this.qunCode = data[1].image;
        }
      });
    },
    showLogin() {
      if (window.location.href.indexOf("/chat") > -1) {
        this.$store.commit("user/SET_HEADER_LOGIN_JUMP", true);
        return;
      }
      this.isShowLogin = true;
      sensors.track("login_show");
    },
    closeUserInfoDialog() {
      this.isUserDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  overflow-y: hidden;
  width: 100%;
  .layout-main-header {
    background: #fff;
    position: relative;
    width: 100%;
    height: 66px;
  }
  .layout-main-container {
    position: relative;
    display: flex;
    margin: 0 auto;
    height: 100%;
    .layout-main-left {
      width: 180px;
      background: var(--layout-slider-background-color);
      margin-right: 39px;
    }
    .layout-main-right {
      display: flex;
      flex-direction: column;
      flex: 1;
      /* width: calc(100% - $layoutSliderWidth);
      flex-shrink: 0; */
      min-width: 200px;
      // background: #F8FAFF;
      height: calc(100% - 66px);
      .header-con {
        height: 56px;
      }
      .layout-right-content {
        /* @include scrollBar(0); */
        flex: 1;
        overflow: hidden;
        /* overflow-y:scroll; */
        /* height: calc(100% - 56px); */
        // padding: 0px 58px 0 16px;
        // margin-top: 16px;
        // overflow: auto;
      }
    }
  }
  #loginIrame {
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
    top: 0px;
    left: 0px;
    z-index: 999999;
  }
}
.layout-main-aides {
  position: absolute;
  bottom: 150px;
  right: 0;
  z-index: 9999;
}
</style>
